import mailTipsDatapoints, {
    MailTipsViewStateMap,
    MailTipsType,
} from 'owa-mail-tips/lib/datapoints';
import { logUsage } from 'owa-analytics';

/**
 * Logs mailtips on remove action
 * @param mailTipsViewStateMap is the mailTips viewstate
 */
export default function logRecipientRemovedFromRecipientWellDatapoint(
    mailTipsViewStateMap: MailTipsViewStateMap
) {
    if (
        Object.keys(mailTipsViewStateMap).some(
            key => mailTipsViewStateMap[key] != MailTipsType.None
        )
    ) {
        const {
            name: RecipientRemovedFromRecipientWellDatapointName,
            customData: RecipientRemovedFromRecipientWellDatapointCustomData,
        } = mailTipsDatapoints.RecipientRemovedFromRecipientWellDatapoint.datapoint;
        logUsage(
            RecipientRemovedFromRecipientWellDatapointName,
            RecipientRemovedFromRecipientWellDatapointCustomData(mailTipsViewStateMap)
        );
    }
}
